const apiBase = 'http://localhost/selforder/api/';
const imageBase = '../public/img';

export { apiBase, imageBase };



// WEBPACK FOOTER //
// ./src/components/shared/global.js